import { useAuth } from '../contexts/AuthContext';
import { adminGuide } from '../content/adminGuide';
import GuideReader from '../components/documentation/GuideReader';

export default function AdminDocumentation() {
  const { userProfile } = useAuth();
  const articles = adminGuide.filter(article => !article.adminOnly || userProfile?.role === 'admin');
  return <GuideReader title="Guía de la plataforma" description="Cómo revisar documentos, administrar usuarios y configurar requisitos." articles={articles} />;
}
